<script>
export default {
    name: 'IconFilter'
}
</script>
<template>
    <svg
        class="base-icon icon-filter"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M56 16v4L36 36v12l-8 8V36L8 20v-4h48zM8 8h48v4H8V8z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
